import React, { useEffect, useState } from 'react'
import { FaBuilding } from 'react-icons/fa'
import { CompanyNameFormProps } from '../../../types/onboardingTypes'
import { NextButton } from '../shared/Buttons'
import { Theme } from '../../../lib/theme';

const CompanyNameForm: React.FC<CompanyNameFormProps> = ({
  onContinue,
  initialData,
  isNextLoading,
}) => {
  const [companyName, setCompanyName] = useState(initialData)

  useEffect(() => {
    setCompanyName(initialData)
  }, [initialData])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCompanyName(e.target.value)
  }

 
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (companyName) {
      onContinue({ companyName })
    }
  }

  return (
<div className="lg:p-0 p-2 w-full mt-[4rem] md:h-[90%] md:w-[80%] md:shadow-lg md:rounded-3xl md:flex md:flex-col md:items-center md:justify-between md:p-4"
     style={{ backgroundColor: Theme.colors.background }}
>
  {/* Full-height flex container */}
  <div className="flex flex-col h-full w-full items-center">
    
    {/* Heading Section */}
    <div className="flex flex-col items-center gap-1 p-2 lg:p-0">
      <FaBuilding
        className="mb-2 text-6xl lg:text-4xl xl:text-6xl"
        style={{ color: Theme.colors.primary }}
      />
      <h1
        className="text-2xl font-bold"
        style={{ color: Theme.colors.text.strong }}
      >
        Organization Name
      </h1>
      <p style={{ color: Theme.colors.text.weak }}>
        Provide your organization name
      </p>
    </div>

    {/* Input Form */}
    <form onSubmit={handleSubmit} className="w-full max-w-sm mx-auto flex-grow flex flex-col justify-center">
      <div className="w-full py-4">
        <label
          htmlFor="companyName"
          className="mb-3 font-semibold block text-left"
          style={{ color: Theme.colors.text.default }}
        >
          Organization Name / Individual Name
        </label>
        <input
          type="text"
          id="companyName"
          placeholder="Enter organization name"
          className="mb-4 w-full rounded-xl border outline-none"
          style={{
            padding: '1rem',
            borderColor: Theme.colors.stroke.weak,
            color: Theme.colors.text.default,
            backgroundColor: Theme.colors.background,
            caretColor: Theme.colors.primary,
          }}
          value={companyName}
          onChange={handleInputChange}
          onFocus={(e) => {
            e.target.style.boxShadow = `0 0 0 2px ${Theme.colors.button.primary}`;
          }}
          onBlur={(e) => {
            e.target.style.boxShadow = 'none';
          }}
        />
      </div>
    </form>

    {/* Button Section */}
    <div className="lg:w-[40%] w-full flex flex-col items-center p-2 mt-auto lg:pb-[8.5rem]">
      {isNextLoading ? (
        <div
          className="w-10 h-10 border-4 rounded-full animate-spin"
          style={{
            borderColor: Theme.colors.stroke.weak,
            borderTopColor: Theme.colors.button.primary,
          }}
        ></div>
      ) : (
        <NextButton
          disabled={!companyName}
          text={'Continue'}
          onClick={handleSubmit}
        />
      )}
    </div>
  </div>
</div>

  )
}

export default CompanyNameForm
